import React from 'react';
import last from 'lodash/last';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as ResourceApi from 'api/resources';
import {extractResourceIdsWithPath} from 'utils/DBUtils';
import AutoSaveImagePicker from 'components/forms/AutoSaveFormFields/AutoSaveImagePicker';
import {createResourceTypeSelector} from 'resources/selectors';
import {
  createImageAction,
  deleteImageAction,
  startEditImageAction,
  uploadOriginalAndCreateImageAction
} from 'pages/Images/actions';
import {isNoU} from "../utils/DBUtils";

const ImagePickerWrapper = props => (
  <AutoSaveImagePicker
    {...props}
    fieldLabel={props.label}
    field={{
      name: props.name,
      labelKey: props.labelKey,
      placeholderKey: props.placeholderKey
    }}
    helpContent={props.helpContent}
    helpHeader={props.helpHeader}
    required={props.required}
    defaultValue={props.value}
    onValueChanged={props.onValueChanged}
    isSaving={props.isSaving}
    errors={props.errors}
    savedField={props.savedField}
    onPersistValue={(field, value, platform) => props.onValueChanged(value, platform)} />
);

const getImageItems = createResourceTypeSelector(ResourceApi.Types.Image);

const mapStateToProps = (state, ownProps) => {
  const {formProxy} = ownProps;
  const {id} = formProxy.currentResource.resourceId;
  const field = last(formProxy.fieldPath);

  const {creatingImageFor} = state.images;
  const loading = !!creatingImageFor && id === creatingImageFor.id && field === creatingImageFor.field;

  const possibleImages = getImageItems(state.resources);

  const idAssetValue = formProxy.resource.imageId;

  return {
    loading,
    idAssetValue,
    possibleImages
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const {formProxy} = ownProps;
  const rootResource = formProxy.baseResource;
  const modifiedResource = formProxy.resource;
  const {resourcePath} = formProxy;
  // No master for prize object
  const parentIds = extractResourceIdsWithPath(rootResource, rootResource, resourcePath);
  const field = last(formProxy.fieldPath);

  const args = [ownProps.imageType, rootResource, modifiedResource.resourceId, resourcePath, formProxy.fieldPath, field, parentIds];

  return bindActionCreators({
    onBrowse: () => uploadOriginalAndCreateImageAction(...args),
    deleteImage: deleteImageAction,
    editImage: image => createImageAction(image.originalImageId, ...args),
    editImageInfo: imageId => startEditImageAction(imageId),
    onImageClicked: image => (console.log('image clicked', image), {type: 'not implemented'})
  }, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    getPossibleImages: () => stateProps.possibleImages,
    getImageOptions: () => {
      let props = stateProps;
      let options = props.possibleImages.map((image) => ({
        value: image.id,
        text: image.name
      }));

      // Push current image so it shows in dropdown as selected
      if (props.idAssetValue) {
        options.push({
          value: props.idAssetValue,
          text: props.idAssetValue
        });
      }

      // If there is no value put null option to beginning of options
      if (isNoU(props.defaultValue) || props.defaultValue === "") {
        options.unshift({
          value: null,
          text: "-- Select Image --"
        });
      }

      return options;
    },
    editImageInfo: () => dispatchProps.editImageInfo(ownProps.value)
  };
};

const PrizeImagePicker = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ImagePickerWrapper);

export default PrizeImagePicker;



// WEBPACK FOOTER //
// ./public/hoc/PrizeImagePicker.jsx